<template>
  <div class="index-item">
    <div v-if="itemArr.length !== 0">
      <div class="item-card" v-for="(item, index) in itemArr" :key="index" @click="lookDetail(item.order_id,item.order_status)">
        <div class="card-left">
          <div :class="[item.order_status===2?'text-green':'text-orange']">{{item.order_status_name}}</div>
          <div>{{item.goods}}</div>
          <div>{{item.create_time}}</div>
        </div>
        <div class="card-right">
          <div>{{item.gun_money}}元</div>
          <div>{{item.oil_num}}升</div>
        </div>
        <div class="card-icon"></div>
      </div>
    </div>
    <div v-else class="item-null">
        暂无收银数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexItem',
  components: {},

  props: {
    itemArr : {
      type: Array,
      require: true,
      default: function () {
        return [];
      }
    },
  },
  methods:{
    lookDetail(id,status){
      if (status !== 2 && status !== 3){
        this.$router.push('/orderList')
      }else{
        this.$router.push({
          path:'/orderDetail',
          query:{
            order_id: id
          }
        })
      }

    }
  },
  computed: {

  },
}
</script>

<style scoped lang="less">
  .index-item{
    height: 272px;
    padding: 15px;
    .item-card{
      display: flex;
      //align-items: center;
      height: 109px;
      background-color: #fff;
      box-shadow: 0 5px 12px 0 rgba(83, 47, 230, 0.12);
      border-radius: 6px;
      margin-bottom: 15px;
      padding: 15px 10px 15px 15px;
      color: #555;
      font-size: 14px;

      .card-left{
        flex: 1;
        div:first-child {
          height: 25px;
          line-height: 25px;
          font-size: 18px;
          font-weight: 600;

        }
        div:nth-child(2) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #555;
          font-size: 14px;
        }
        div:nth-child(3) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #888;
        }
        .text-orange{
          color: #F84728
        }
        .text-green{
          color: #64C45C
        }
      }
      .card-right{
        text-align: right;
        margin-right: 10px;
        div:first-child {
          height: 25px;
          line-height: 25px;
          color: #333;
          font-size: 18px;
          font-weight: 600;

        }
        div:nth-child(2) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #555;
          font-size: 14px;
        }
      }
      .card-icon{
        height: 12.5px;
        width: 7.5px;
        margin-top: 25px;
        background: url(../assets/arrow-right@2x.png) no-repeat;
        background-size: 100%;
      }

    }
    .item-null{
      color: #888888;
      font-size: 15px;
      text-align: center;
      line-height: 250px;
    }
  }
</style>
